import { Data, TransformsList } from 'cio/utils/analytics/transforms';
import TagModel from 'cio/models/tag';

const Transforms: TransformsList = {
  base({ model, environmentId }: Data & { environmentId: string }) {
    return {
      'Tag ID': `${environmentId}tag${model!.id}`,
      'Tag Name': model!.name,
      'Campaign Usage Count': model!.campaignsUsed,
      'Newsletter Usage Count': model!.newslettersUsed,
      'Broadcast Usage Count': model!.apiTriggeredUsed,
      'Segment Usage Count': model!.segmentsUsed,
    };
  },
  indexTotals({ tags }: Data & { tags: TagModel[] }) {
    let totals = tags.reduce(
      (acc, tag) => {
        acc.campaigns += tag.campaignsUsed;
        acc.broadcasts += tag.apiTriggeredUsed;
        acc.newsletters += tag.newslettersUsed;
        acc.segments += tag.segmentsUsed;
        return acc;
      },
      {
        campaigns: 0,
        broadcasts: 0,
        newsletters: 0,
        segments: 0,
      },
    );

    return {
      'Tag Count Total': tags.length,
      'Campaign Usage Count Total': totals.campaigns,
      'Newsletter Usage Count Total': totals.newsletters,
      'Broadcast Usage Count Total': totals.broadcasts,
      'Segment Usage Count Total': totals.segments,
      'Tag Names': tags.map((tag) => tag.name),
    };
  },
};

export default Transforms;
